module.exports = __webpack_public_path__ + "img/tarj1-1.8b0d8790.svg";